import React from 'react';

const FinancialEntryInstallmentNumber = ({ form, value }) => {
  const totalInstallments = form.getFieldValue('totalInstallments');

  return <span className="gx-fs-lg">{`${value}/${totalInstallments}`}</span>;
};
export default FinancialEntryInstallmentNumber;
